import {batch} from 'react-redux';
import {CardType, TaskType} from '../../constants/dataEnum';
import {addCardTask} from '../actions/cardStateAction';
import {generateCardIDAndTaskIDAndNumber} from './commonTaskListBusiness';
import {globalAddUndoItem} from './undoRedoBusinessAction';
import {removeAllVirtualTrayLabwares} from './labwareBusinessAction';

export const addConsolidateTipsTask = () => (dispatch, getState) => {
  const state = getState();
  const {cardState} = state;
  const {cards, tasks} = cardState;

  const cardType = CardType.CONSOLIDATE_TIPS;

  const cardName = 'Consolidate Tips';
  const [cardID, taskID, taskNumber] = generateCardIDAndTaskIDAndNumber(cards, tasks, cardType, null);

  const task = {
    ID: taskID,
    number: taskNumber,
    type: TaskType.CONSOLIDATE_TIPS,
  };

  dispatch(addCardTask(cardID, cardName, cardType, task.ID, task));
};

export const processCreateConsolidateTips = () => (dispatch) => {
  batch(() => {
    dispatch(addConsolidateTipsTask());
    dispatch(removeAllVirtualTrayLabwares());
    dispatch(globalAddUndoItem());
  });
};
